<template>
  <div class="d-flex">
    <div mr="0.5">
      <template v-if="!disabled">
        <i class="bi bi-tag" @click="openSelect()"></i>
        <div class="position-relative">
          <div :class="`position-absolute tags-multiselect-wrapper ${hiddenTagSelectWrapper}`">
            <vue-multiselect
              ref="multiselect"
              track-by="id"
              label="title"
              :options="options" 
              :multiple="true"
              :close-on-select="false"
              :blockKeys="['Delete']"
              :loading="isLoading"
              :taggable="tenantPresent"
              :value="tags"
              :noOptions="$t('select.noOptions')"
              :deselectLabel="$t('select.deselectLabel')"
              :selectedLabel="$t('select.selectedLabel')"
              :selectLabel="$t('select.selectLabel')"
              :placeholder="$t('select.placeholder')"
              openDirection="above"
              @open="isOpen = true"
              @close="isOpen = false"
              :tagPlaceholder="$t('newPlaceholder')"
              @search-change="asyncFind"
              @tag="createTag"
              @remove="remove"
              @select="select"
            >
              <template slot="tag">{{ '' }}</template>
            </vue-multiselect>
          </div>
        </div>
      </template>
      <template v-else>
        <i class="bi bi-tag"></i>
      </template>
    </div>
    <div class="flex-grow-1 task-card-tags__container" ref="tags">
      <div class="task-card-tags">
        <template v-for="(tag, index) in tags">
          <vue-admin-tasks-task-tag :tag="tag" :key="index"></vue-admin-tasks-task-tag>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  import { ERROR_TYPES } from './tasksConsts';

  export default {
    data: function () {
      return {
        options: [
        ],
        isOpen: false,
        mounted: false,
        isLoading: false,
      }
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      taskData: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      ...mapActions('taskStoreModule', ['emitTaskError', 'addTag', 'removeTag']),
      openSelect(){
        this.$refs.multiselect.activate()
      },
      addScrollRight(){
        let currentLeft = this.$refs.tags.scrollLeft;
        this.$refs.tags.scrollLeft = currentLeft + 10;
      },
      addScrollLeft(){
        let currentLeft = this.$refs.tags.scrollLeft;
        this.$refs.tags.scrollRight = currentLeft - 10;
      },
      asyncFind(query){
        if(query.length > 2){
          this.isLoading=true;
          this.$apiService.tagsAutocomplete({
            term: query,
            onSucess: (response) => {
              this.options = response.data
              this.isLoading=false
            },
            onError: () => {
              this.emitTaskError({renderId: this.taskData.renderId, errorType: ERROR_TYPES.searchTagError})
            }
          })
        }else{
          this.options = [...this.tags];
        }
      },
      createTag(tag){
        this.isLoading = true
        this.$apiService.createTag({
          tagData: {title: tag},
          onSucess: (response) => {
            let instance = {id: response.data.id, title: response.data.title, color: response.data.color}
            this.isLoading = false
            this.options.push(instance)
            this.select(instance)
          },
          onError: () => {
            this.emitTaskError({renderId: this.taskData.renderId, errorType: ERROR_TYPES.newTagError})
          }
        })
      },
      select(tag){
        this.addTag({tag: tag, task_id: this.taskData.id, renderId: this.taskData.renderId})
      },
      remove(tag){
        this.removeTag({tag: tag, task_id: this.taskData.id, renderId: this.taskData.renderId})
      }
    },
    computed: {
      ...mapState('taskStoreModule', ['tenantPresent']),
      hiddenTagSelectWrapper: function(){
        return !this.isOpen ? 'hidden' : ''
      },
      tags: function(){
        return this.taskData.tags
      }
    },
    watch: {
      tags: function(newValue){
        this.options = [...newValue]
      }
    },
    mounted(){
      this.mounted = true;
      this.options = [...this.taskData.tags]
      console.log("tenantPresent")
      console.log(this.tenantPresent)
    },
    i18n: {
      messages: {
        "pt-BR": {
          newPlaceholder: 'Aperte enter para criar a tag' 
        },
        en: {
          newPlaceholder: 'Press enter to create a new tag' 
        }
      }
    }
  }
</script>

